module.exports = __webpack_public_path__ + "img/special5.af29656a.png";